import { render, staticRenderFns } from "./car-forecast-add-or-update.vue?vue&type=template&id=27f6ec36"
import script from "./car-forecast-add-or-update.vue?vue&type=script&lang=js"
export * from "./car-forecast-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports